import { Inbox, Receipt, Calculator, PhoneCall, MessagesSquare, Sparkles } from "lucide-react";

export const services = [
  {
    icon: Inbox,
    kicker: "Lead- & Anfrage-Bot",
    title: "Keine Anfrage geht mehr verloren",
    text: "Ob Telefon, WhatsApp, Formular oder Chat — jede Anfrage wird automatisch erfasst, qualifiziert und landet sofort bei Ihnen.",
    points: ["Alle Kanäle an einem Ort", "Automatische Qualifizierung", "Sofort-Benachrichtigung"],
  },
  {
    icon: Receipt,
    kicker: "Rechnungserfassung",
    title: "Belege erfassen sich von selbst",
    text: "Eingehende Rechnungen werden automatisch erfasst und strukturiert abgelegt — kein manuelles Abtippen mehr.",
    points: ["Automatische Belegerfassung", "Strukturierte Ablage", "Weniger Tipparbeit"],
  },
  {
    icon: Calculator,
    kicker: "Für den Steuerberater",
    title: "Rechnungen fertig für die Übergabe",
    text: "Belege und Rechnungen werden automatisiert so aufbereitet, dass Ihr Steuerberater sie direkt übernehmen kann.",
    points: ["Automatische Aufbereitung", "Weniger Rückfragen", "Schnellere Buchhaltung"],
  },
  {
    icon: PhoneCall,
    kicker: "Anrufbot",
    title: "Die Hotline nimmt auch ohne Sie ab",
    text: "Ein Anrufbot beantwortet Standardanfragen an Ihrer Hotline und leitet nur die wirklich wichtigen Anrufe weiter.",
    points: ["24/7 erreichbar", "Beantwortet Standardfragen", "Leitet Wichtiges weiter"],
  },
  {
    icon: MessagesSquare,
    kicker: "FAQ-Bot",
    title: "Ihre Website antwortet rund um die Uhr",
    text: "Ein FAQ-Assistent beantwortet die häufigsten Fragen zu Öffnungszeiten, Leistungen und Preisen — auch nach Feierabend.",
    points: ["24/7 erreichbar", "Entlastet Ihr Team", "Beantwortet Standardfragen"],
  },
  {
    icon: Sparkles,
    kicker: "Individuelle Lösung",
    title: "Wir sind so individuell wie Sie",
    text: "Gemeinsam schauen wir uns an, welche wiederkehrenden Aufgaben sich in Ihrem Betrieb automatisieren lassen — maßgeschneidert statt von der Stange.",
    points: ["Gemeinsame Analyse", "Maßgeschneidert", "Kein Standardpaket"],
  },
];

export default services;
